export type ClientPlatform = 'ios' | 'android' | 'desktop';

/**
 * Detecção de device do NAVEGADOR ATUAL (client-side). Não confundir com
 * `isIosDevice`/`isAndroidDevice` de `passbook-utils.ts`, que operam sobre
 * dispositivos já cadastrados no Mongo (histórico de leads), não sobre quem
 * está acessando a página agora.
 */
export function detectClientPlatform(): ClientPlatform {
  const ua = navigator.userAgent;
  if (/iPhone|iPad|iPod/i.test(ua)) return 'ios';
  // iPadOS 13+ no Safari se apresenta como Mac; o toque é o que denuncia o iPad.
  if (/Macintosh/i.test(ua) && navigator.maxTouchPoints > 1) return 'ios';
  if (/Android/i.test(ua)) return 'android';
  return 'desktop';
}

/** Computador da Apple (no Mac, o `.pkpass` vai para a Carteira do iPhone pela conta Apple). */
export function isMacDesktop(): boolean {
  return /Macintosh|Mac OS X/i.test(navigator.userAgent);
}

/**
 * `typeAccess` como a legacy-api espera ("iOS" | "Android"): o legado sempre
 * força "Android" para qualquer UA que não seja iOS, inclusive desktop — é o
 * bug que fazia o form abrir normal em PC mas empurrar o fluxo de Google
 * Wallet quebrado. Replicamos essa coerção só para o payload da API (a UI usa
 * `detectClientPlatform()` para decidir a tela certa, incluindo o handoff de
 * desktop).
 */
export function legacyTypeAccess(platform: ClientPlatform): 'iOS' | 'Android' {
  return platform === 'ios' ? 'iOS' : 'Android';
}
